import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  saveOrUpdate,
  getServiceGroupById,
  deleteServiceGroupById,
  pagingServiceGroup,
} from "app/services/ServiceGroupService";
import { ServiceGroup } from "app/common/Model/ServiceGroup";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import {
  downloadTemplateServiceGroup,
  importExcelServiceGroup,
} from "app/services/ImportExcelService";

export default class ServiceGroupStore {
  searchServiceGroup = new SearchObject({ parentId: null });
  pageServiceGroup = null;
  selectedServiceGroup = new ServiceGroup();
  openFormCreateOrEdit = false;
  openConfirmDeleteServiceGroup = false;
  listAllServiceGroups = [];
  recentlyUpdated = false;
  pageSize = 10;
  page = 1;

  constructor() {
    makeAutoObservable(this);
  }

  getAllServiceGroup = async () => {
    if (!this.listAllServiceGroups?.length || this.recentlyUpdated) {
      const searchObjectForAll = {
        pageIndex: 1,
        pageSize: 1000000,
      };
      return await pagingServiceGroup(searchObjectForAll)
        .then(({ data }) => {
          this.listAllServiceGroups = data?.content;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  };
  getAllServiceGroupByType = async (type) => {
    if (!this.listAllServiceGroups?.length || this.recentlyUpdated) {
      const searchObjectForAll = {
        pageIndex: 1,
        pageSize: 1000000,
        type: type,
      };
      return await pagingServiceGroup(searchObjectForAll)
        .then(({ data }) => {
          this.listAllServiceGroups = data?.content;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  };
  setRowsPerPage = (value) => {
    this.pageSize = value;
    this.page = 1;
    this.handleChangeFormSearchGroup();
  };

  pagingServiceGroups = async () => {
    return await pagingServiceGroup(this.searchServiceGroup)
      .then(({ data }) => {
        this.pageServiceGroup = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchServiceGroup) => {
    this.searchServiceGroup = checkSearchObject(
      this.searchServiceGroup,
      searchServiceGroup
    );
    this.pagingServiceGroups();
  };

  handleChangeFormSearchGroup = (searchService) => {
    this.searchServiceGroup = {
      ...this.searchServiceGroup,
      ...searchService,
      pageSize: this.pageSize,
    };
    this.pagingServiceGroups();
  };

  handleOpenFormCreateOrEdit = (serviceGroupId) => {
    if (Boolean(serviceGroupId)) {
      getServiceGroupById(serviceGroupId)
        .then(({ data }) => {
          this.selectedServiceGroup = data;
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedServiceGroup = new ServiceGroup();
      this.openFormCreateOrEdit = true;
    }
  };

  saveOrUpdate = async (serviceGroup, { setSubmitting }) => {
    return await saveOrUpdate(serviceGroup)
      .then(() => {
        this.selectedServiceGroup = new ServiceGroup();
        toast.success("Lưu thông tin nhóm dịch vụ thành công!");
        this.handleClosePopup();
        this.pagingServiceGroups();
        this.recentlyUpdated = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin nhóm dịch vụ có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDeleteServiceGroup = (serviceGroup) => {
    this.selectedServiceGroup = { id: serviceGroup?.id };
    this.openConfirmDeleteServiceGroup = true;
  };

  handleConfirmDeleteServiceGroup = async () => {
    return await deleteServiceGroupById(this?.selectedServiceGroup?.id)
      .then(() => {
        if (
          this.searchServiceGroup.pageIndex > 1 &&
          this.pageServiceGroup.content.length === 1
        ) {
          this.searchServiceGroup.pageIndex -= 1;
        }
        toast.success("Xóa nhóm dịch vụ thành công!");
        this.handleClosePopup();
        this.recentlyUpdated = true;
        this.pagingServiceGroups();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa nhóm dịch vụ có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteServiceGroup = false;
  };

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplateServiceGroup();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "NHOM_DICH_VU.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };
  SubmitExcelServiceGroup = (file) => {
    importExcelServiceGroup(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchServiceGroup = {
          ...this.searchServiceGroup,
          pageIndex: 1,
        };
        this.getAllServiceGroup();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };

  resetStore = () => {
    this.searchServiceGroup = new SearchObject();
    this.pageServiceGroup = null;
    this.selectedServiceGroup = new ServiceGroup();
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteServiceGroup = false;
  };

  resetStorePopupServiceGroup = () => {
    this.searchServiceGroup = new SearchObject();
    this.pageServiceGroup = null;
    this.selectedServiceGroup = new ServiceGroup();
  };

}
